import Vue from 'vue'
import PortalVue from 'portal-vue'
import VueMask from 'v-mask'
import Vue2TouchEvents from 'vue2-touch-events'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import store from './state/store'
import router from './router'
import App from './App.vue'
import Hero from '@/components/Hero'

// Setup for global filters
import './filters/_global'

// Import base DR components globally
import '@mannum/dr-components'

// Styles
import './assets/css/app.css'

// Import + register SVGs globally
import './assets/svg'

// Handle customer portal messages
import '@/lib/customerPortal'

Vue.component('Hero', Hero)

Vue.use(PortalVue)
Vue.use(VueMask)
Vue.use(Vue2TouchEvents)

if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    release: process.env.VUE_APP_COMMIT_REF,
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
  })
}

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (window.Cypress) {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const app = new Vue({
  router,
  store,
  mounted () {
    if (window !== window.parent) {
      window.addEventListener(
        'message',
        (event) => {
          if (event.data.type === 'start-gtm') this.loadGtm()
          if (event.data.type === 'reinit-buttons') this.handleDrLauncherMsgReinitButtons()
        },
        false
      )
    } else {
      this.loadGtm()
    }
  },
  methods: {
    loadGtm () {
      const ga = window[window.GoogleAnalyticsObject || 'ga']

      if (typeof ga !== 'function') {
        ;(function (w, d, s, l, i) {
          w[l] = w[l] || []
          w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js',
          })
          const f = d.getElementsByTagName(s)[0]
          const j = d.createElement(s)
          const dl = l !== 'dataLayer' ? '&l=' + l : ''
          j.async = true
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
          f.parentNode.insertBefore(j, f)
        })(window, document, 'script', 'dataLayer', 'GTM-TJHXMM4')
      }
    },
    handleDrLauncherMsgReinitButtons () {
      // @TODO - Make DRY: this is mostly a copy from handleLoaded in /router/index.js
      // Check the store not already loaded
      const quoteReference = this.$store.getters.getReference
      const products = this.$store.getters.getProducts

      // calculate total number of products configured (to be send to parent window for launcher)
      let totalProducts = 0
      products.forEach((product) => {
        product.rates.forEach((rate) => {
          if (rate.key !== 'CommercialCombined\\MinimumPremiumAdjustment') totalProducts += 1
        })
      })

      // post message from iframe to parent window to handle launcher status
      window.parent.postMessage(
        {
          type: 'status-sync',
          payload: {
            from: 'dr-widget',
            quoteActive: !!quoteReference,
            totalProducts,
          },
        },
        '*'
      )
    },
  },
  render: h => h(App),
}).$mount('#app')

// If running inside Cypress...
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
